import { render, staticRenderFns } from "./ColapsableSalidasTable.vue?vue&type=template&id=79acceb6&scoped=true"
import script from "./ColapsableSalidasTable.vue?vue&type=script&lang=ts"
export * from "./ColapsableSalidasTable.vue?vue&type=script&lang=ts"
import style0 from "./ColapsableSalidasTable.vue?vue&type=style&index=0&id=79acceb6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79acceb6",
  null
  
)

export default component.exports